module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY2Ni40IDg5NmEzMiAzMiAwIDAgMSAwIDY0aC0zMjBhMzIgMzIgMCAxIDEgMC02NGgzMjB6IG0tMTM5LjItODI0LjNhMzIgMzIgMCAwIDEgMy41IDMuNWwzMTQuNCAzNjYuOGEzMiAzMiAwIDAgMS0yNC4zIDUyLjhoLTEyMi40djI4OGEzMiAzMiAwIDAgMS0zMiAzMmgtMzIwYTMyIDMyIDAgMCAxLTMyLTMydi0yODhIMTkyYTMyIDMyIDAgMCAxLTI0LjMtNTIuOGwzMTQuNS0zNjYuOGEzMiAzMiAwIDAgMSA0NS4xLTMuNXoiIGZpbGw9IiMwIiBwLWlkPSIzNjc4Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Upgrade-filled.svg
// module id = Kc/L
// module chunks = 74